import { useState } from "react";

// Components
import ConfirmDialog from "../../UI/ConfirmDialog/ConfirmDialog";

// Icons
import { Trash } from "../../../SVGS";

// Styles
import { ServiceCommentStyles } from "./serviceComment.styles";

// Utils
import {
  convertTimeStampToDateWithSlash,
  convertTimeStampToLocalTime
} from "../../../utils/timeStampToDate";

const getInitials = (firstName = "", lastName = "") => {
  const first = firstName.trim().charAt(0);
  const last = lastName.trim().charAt(0);
  return `${first}${last}`.toUpperCase() || "?";
};

const ServiceComment = ({ serviceComment, deleteComment }) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);

  const { firstName, lastName, profileImage } = serviceComment.user;
  const hasImage = !!profileImage?.url && !imageFailed;

  const handleConfirm = () => {
    setIsConfirmOpen(false);
    deleteComment();
  };

  return (
    <ServiceCommentStyles>
      <div className="commentUserRow">
        <div className="commentUser">
          <div className="commentUserDetails">
            <div className="commentAvatar">
              {hasImage ? (
                <img
                  src={profileImage.url}
                  alt="profile"
                  className="commentProfileImage"
                  onError={() => setImageFailed(true)}
                />
              ) : (
                <span className="commentAvatarInitials">
                  {getInitials(firstName, lastName)}
                </span>
              )}
            </div>
            <div className="commentUserMeta">
              <h5 className="commentUserName">{`${firstName} ${lastName}`}</h5>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="commentDeleteBtn"
          aria-label="Delete comment"
          onClick={() => setIsConfirmOpen(true)}
        >
          <Trash />
        </button>
      </div>

      <div className="commentBody">
        <p className="commentText">{serviceComment.comment}</p>
      </div>
      <div className="commentDateRow">
        <p className="commentDate">
          {new Date(serviceComment.createdAt * 1000).setHours(0, 0, 0, 0) ===
          new Date().setHours(0, 0, 0, 0)
            ? convertTimeStampToLocalTime(serviceComment.createdAt)
            : convertTimeStampToDateWithSlash(serviceComment.createdAt)}
        </p>
      </div>
      <ConfirmDialog
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirm}
        title="Delete Comment?"
        message="Are you sure you want to delete this comment? This action cannot be undone."
      />
    </ServiceCommentStyles>
  );
};

export default ServiceComment;
